import type { ServiceOption } from "../types/services"

export const hrOutsourcingServices: ServiceOption[] = [
  {
    id: "hr-structuring",
    name: "HR Structuring",
    description: "Complete HR department setup and organizational structure",
    icon: "🏢",
    checklist: [
      { id: "org-chart", name: "Organizational Chart Development", selected: false },
      { id: "job-descriptions", name: "Job Descriptions & Specifications", selected: false },
      { id: "reporting-structure", name: "Reporting Structure Setup", selected: false },
      { id: "hr-policies", name: "HR Policies & Procedures", selected: false },
      { id: "performance-framework", name: "Performance Management Framework", selected: false },
      { id: "others-hr-structuring", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "business-branding",
    name: "Business Branding",
    description: "Corporate identity and brand development services",
    icon: "🎨",
    checklist: [
      { id: "logo-design", name: "Logo Design & Brand Identity", selected: false },
      { id: "brand-guidelines", name: "Brand Guidelines & Standards", selected: false },
      { id: "marketing-materials", name: "Marketing Materials Design", selected: false },
      { id: "website-branding", name: "Website Branding & UI/UX", selected: false },
      { id: "social-media-branding", name: "Social Media Branding", selected: false },
      { id: "others-branding", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "employee-audit",
    name: "Employee Audit",
    description: "Comprehensive employee performance and compliance audit",
    icon: "📊",
    checklist: [
      { id: "performance-audit", name: "Performance Assessment Audit", selected: false },
      { id: "compliance-audit", name: "Compliance & Legal Audit", selected: false },
      { id: "payroll-audit", name: "Payroll & Benefits Audit", selected: false },
      { id: "skills-assessment", name: "Skills & Competency Assessment", selected: false },
      { id: "culture-audit", name: "Company Culture Assessment", selected: false },
      { id: "others-audit", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "employee-training",
    name: "Employee Training",
    description: "Professional development and training programs",
    icon: "🎓",
    checklist: [
      { id: "leadership-training", name: "Leadership Development Training", selected: false },
      { id: "technical-training", name: "Technical Skills Training", selected: false },
      { id: "soft-skills-training", name: "Soft Skills Development", selected: false },
      { id: "compliance-training", name: "Compliance & Safety Training", selected: false },
      { id: "onboarding-training", name: "Employee Onboarding Programs", selected: false },
      { id: "others-training", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "employer-branding",
    name: "Employer Branding",
    description: "Build and enhance your employer brand reputation",
    icon: "⭐",
    checklist: [
      { id: "employer-value-prop", name: "Employer Value Proposition", selected: false },
      { id: "recruitment-branding", name: "Recruitment Marketing Materials", selected: false },
      { id: "glassdoor-management", name: "Glassdoor & Review Management", selected: false },
      { id: "career-page", name: "Career Page Development", selected: false },
      { id: "employee-testimonials", name: "Employee Testimonials & Stories", selected: false },
      { id: "others-employer-branding", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "denax-hr-software",
    name: "HR, Accounting, and Communications Software (DenaxHR)",
    description: "Complete HR management software solution",
    icon: "💻",
    checklist: [
      { id: "payroll-management", name: "Payroll Management System", selected: false },
      { id: "employee-database", name: "Employee Database Management", selected: false },
      { id: "time-attendance", name: "Time & Attendance Tracking", selected: false },
      { id: "performance-management", name: "Performance Management Module", selected: false },
      { id: "accounting-integration", name: "Accounting System Integration", selected: false },
      { id: "communication-tools", name: "Internal Communication Tools", selected: false },
      { id: "reporting-analytics", name: "HR Reporting & Analytics", selected: false },
      { id: "others-software", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "change-management",
    name: "Change Management",
    description: "Organizational change and transformation support",
    icon: "🔄",
    checklist: [
      { id: "change-strategy", name: "Change Management Strategy", selected: false },
      { id: "stakeholder-engagement", name: "Stakeholder Engagement Plan", selected: false },
      { id: "communication-plan", name: "Change Communication Plan", selected: false },
      { id: "training-support", name: "Change Training & Support", selected: false },
      { id: "resistance-management", name: "Resistance Management", selected: false },
      { id: "others-change", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "occupational-therapy",
    name: "Occupational Therapy",
    description: "Workplace wellness and occupational health services",
    icon: "🏥",
    checklist: [
      { id: "workplace-assessment", name: "Workplace Ergonomic Assessment", selected: false },
      { id: "injury-prevention", name: "Injury Prevention Programs", selected: false },
      { id: "return-to-work", name: "Return-to-Work Programs", selected: false },
      { id: "wellness-programs", name: "Employee Wellness Programs", selected: false },
      { id: "mental-health", name: "Mental Health Support", selected: false },
      { id: "others-therapy", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "professional-consultation",
    name: "Professional Consultation",
    description: "Expert HR and business consultation services",
    icon: "👔",
    checklist: [
      { id: "hr-strategy", name: "HR Strategy Development", selected: false },
      { id: "legal-compliance", name: "Legal Compliance Consultation", selected: false },
      { id: "compensation-benefits", name: "Compensation & Benefits Design", selected: false },
      { id: "organizational-development", name: "Organizational Development", selected: false },
      { id: "merger-acquisition", name: "Merger & Acquisition HR Support", selected: false },
      { id: "others-consultation", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "employability-training",
    name: "Employability Training",
    description: "Skills development for job readiness and career advancement",
    icon: "🚀",
    checklist: [
      { id: "resume-writing", name: "Resume Writing & Optimization", selected: false },
      { id: "interview-skills", name: "Interview Skills Training", selected: false },
      { id: "job-search-strategies", name: "Job Search Strategies", selected: false },
      { id: "networking-skills", name: "Professional Networking Skills", selected: false },
      { id: "career-planning", name: "Career Planning & Development", selected: false },
      { id: "others-employability", name: "Others (Please specify)", selected: false },
    ],
  },
  {
    id: "personal-branding",
    name: "Personal Branding",
    description: "Individual professional brand development",
    icon: "✨",
    checklist: [
      { id: "linkedin-optimization", name: "LinkedIn Profile Optimization", selected: false },
      { id: "personal-website", name: "Personal Website Development", selected: false },
      { id: "portfolio-creation", name: "Professional Portfolio Creation", selected: false },
      { id: "social-media-strategy", name: "Personal Social Media Strategy", selected: false },
      { id: "thought-leadership", name: "Thought Leadership Development", selected: false },
      { id: "others-personal-branding", name: "Others (Please specify)", selected: false },
    ],
  },
]


